var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("vl-textarea", {
    attrs: {
      id: _vm.id,
      name: _vm.name,
      "mod-disabled": _vm.modDisabled,
      "mod-error": _vm.modError,
      "mod-block": _vm.modBlock,
      placeholder: _vm.placeholder,
    },
    model: {
      value: _vm.inputValue,
      callback: function ($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }